import {
    FormSelectionControl,
    createFormSelectionControl,
} from '@vfde-brix/ws10/form-selection-control';
import { startAppListening } from '../../../app/listener';
import { useAppDispatch } from '../../../app/store';
import {
    toggleHardwareOnly,
    selectCustomerConfig,
} from '../slice';

let hardwareOnlySwitch: FormSelectionControl | null = null;

/**
 * Returns the hardwareOnlySwitch or null
 */
export const getHardwareOnlySwitch = () => hardwareOnlySwitch;

/**
 * Mounts the switch (formSelectionControl) component
 * @param containerId ID of the switch container
 * @param isHardwareOnly Boolean checked state
 */
export const mountHardwareOnlySwitch = (
    containerId: string,
    isHardwareOnly: boolean,
): FormSelectionControl | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const dispatch = useAppDispatch();

    const onChange = () => {
        dispatch(toggleHardwareOnly());
    };

    const formSelectionControl = createFormSelectionControl(container, { onChange });
    hardwareOnlySwitch = formSelectionControl;

    updateFormSelectionControl(formSelectionControl, isHardwareOnly);
    listenForUpdates(formSelectionControl);

    return formSelectionControl;
};

const listenForUpdates = (formSelectionControl: FormSelectionControl) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCustomerConfig(currentState).isHardwareOnly !== selectCustomerConfig(previousState).isHardwareOnly
        ,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const customerConfig = selectCustomerConfig(state);
            const { isHardwareOnly } = customerConfig;

            updateFormSelectionControl(formSelectionControl, isHardwareOnly);
        },
    });
};

const updateFormSelectionControl = (formSelectionControl: FormSelectionControl, checked: boolean) => {
    const { items } = formSelectionControl.getProperties();

    /* istanbul ignore if */
    if (!items?.length) {
        return;
    }

    items[0].optState = checked ? 'checked' : undefined;

    formSelectionControl.update({ items });
};
